import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { setToken } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        if (res.data?.token) setToken(res.data.token);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/admin", { replace: true }), 1800);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gl-bg text-gl-text">
      {error ? (
        <p className="text-gl-text2">{error}</p>
      ) : (
        <>
          <Loader2 className="animate-spin text-gl-gold" size={40} />
          <p className="mt-4 text-gl-text2 tracking-wide">Signing you in…</p>
        </>
      )}
    </div>
  );
}
